import { globalVars, razorPayCheckoutLib } from "Config";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { loadScript, postUrl } from "utils";

const RazorPayPGSubUpdate = (props: { data: any, subscription: any, queryParams: any }) => {
    const { subscription, queryParams } = props
    const { PAYMENTS_SERVICE_URL } = globalVars
    const paymentFailed = useRef(false);

    const subscriptionData: any = useMemo(() => {
        try {
            return JSON.parse(decodeURIComponent(queryParams.data.replace(/\+/g, ' ')));
        } catch (err) {
            console.error('Failed to parse subscription data:', err);
            return "";
        }
    }, [queryParams.data]);

    const failureCall = useCallback(() => {
        const param = {
            error: {
                description: "Transaction has been cancelled by user",
                metadata: {
                    subscription_id: subscription?.gateway_subscription_id,
                },
            },
            amount: subscriptionData?.amount,
            currency: "INR"
        }

        postUrl(`${PAYMENTS_SERVICE_URL}/open/razorpay/subscription/redirectAck`, param)
    }, [PAYMENTS_SERVICE_URL, subscription?.gateway_subscription_id, subscriptionData?.amount])

    const callRedirect = useCallback((res: object) => {
        postUrl(`${PAYMENTS_SERVICE_URL}/open/razorpay/subscription/redirectAck`, res)
    }, [PAYMENTS_SERVICE_URL])

    useEffect(() => {
        const displayRazorPay = async () => {
            const res = await loadScript(razorPayCheckoutLib)

            if (!res) {
                alert('Razor pay SDK failed to load')
                return
            }

            const options = {
                //Razorpay client ID
                key: subscription?.metadata?.client_id,
                subscription_id: subscription?.gateway_subscription_id,
                recurring: "1",
                subscription_card_change: true,
                name: "HFN Magazine",
                description: `Update Payment Method - ${subscription?.gateway_subscription_id}`,
                image: "https://cdn-web.heartfulness.org/en/wp-content/uploads/2019/04/05114150/LTM-logo_updated.png",
                handler: (response: Object) => {
                    paymentFailed.current = false;
                    callRedirect(response)
                },
                prefill: {
                    name: subscriptionData?.customer_detail?.customer_name,
                    email: subscriptionData?.customer_detail?.email,
                    contact: subscriptionData?.customer_detail?.phone_number,
                },
                retry: {
                    enabled: false
                },
                modal: {
                    ondismiss: () => {
                        if (!paymentFailed.current) {
                            paymentFailed.current = false;
                            failureCall();
                        }
                    }
                },
                notes: {
                    origin: window.location.origin
                },
                theme: {
                    color: "#3399cc",
                }
            }

            const _window = window as any
            const paymentObject = new _window.Razorpay(options)

            paymentObject.on("payment.failed", (response: any) => {
                paymentFailed.current = true;
                callRedirect({
                    error: {
                        description: response?.error?.description,
                        metadata: { subscription_id: subscription?.gateway_subscription_id },
                    }, amount: subscriptionData?.amount, currency: "INR"
                })
            });
            paymentObject.open();
        }

        displayRazorPay()
    }, [
        callRedirect,
        failureCall,
        PAYMENTS_SERVICE_URL,
        subscription?.gateway_subscription_id,
        subscription?.metadata?.client_id,
        subscriptionData?.amount,
        subscriptionData?.customer_detail?.customer_name,
        subscriptionData?.customer_detail?.email,
        subscriptionData?.customer_detail?.phone_number,
    ])

    return null
}

export default RazorPayPGSubUpdate;